import { HTMLAttributes } from 'react'

import Container from '@/components/base/container'
import Form from '@/components/base/form'
import Section from '@/components/base/section'
import Typography from '@/components/base/typography'

import { WPGravityForm } from '@/types'

export type FormSectionProps = HTMLAttributes<HTMLDivElement> &
  Partial<{
    title: string
    paragraph: string
    form: WPGravityForm
  }>

const FormSection = ({
  title,
  paragraph,
  form,
  ...props
}: FormSectionProps) => {
  return (
    <Section {...props}>
      <Container>
        <div className="flex flex-col gap-[2rem] pt-[10rem]">
          <div className="md:col-span-3 lg:col-span-6">
            <div className="gap-y-spacing-sm flex flex-col">
              {title ? (
                <Typography
                  component="h1"
                  className="text-[2.4rem] text-white lg:text-[3.6rem]"
                >
                  {title}
                </Typography>
              ) : null}
              {paragraph ? (
                <Typography paragraph className="text-[1.6rem] text-white/60">
                  {paragraph}
                </Typography>
              ) : null}
            </div>
          </div>
          <div className="md:col-span-6 lg:col-span-12">
            {form?.id ? (
              <Form
                form_id={form.id}
                fields={form?.fields}
                submit={form?.button?.text}
                theme="dark"
              />
            ) : null}
          </div>
        </div>
      </Container>
    </Section>
  )
}

export default FormSection
